<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.377"
      height="9.584"
      viewBox="0 0 14.377 9.584"
      class="scaling-svg"
    >
      <path
        d="M13.629,9.584H3.942A.748.748,0,0,1,3.2,8.836v-.1a.748.748,0,0,1,.747-.748h9.687a.749.749,0,0,1,.748.748v.1A.749.749,0,0,1,13.629,9.584ZM.8,9.584a.8.8,0,1,1,.8-.8A.8.8,0,0,1,.8,9.584Zm12.83-3.993H3.942A.748.748,0,0,1,3.2,4.843v-.1a.748.748,0,0,1,.747-.748h9.687a.749.749,0,0,1,.748.748v.1A.749.749,0,0,1,13.629,5.591ZM.8,5.591a.8.8,0,1,1,.8-.8A.8.8,0,0,1,.8,5.591ZM13.629,1.6H3.942A.748.748,0,0,1,3.2.85v-.1A.748.748,0,0,1,3.942,0h9.687a.749.749,0,0,1,.748.748v.1A.749.749,0,0,1,13.629,1.6ZM.8,1.6A.8.8,0,1,1,1.6.8.8.8,0,0,1,.8,1.6Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ListMenuIcon extends Vue {}
</script>

<style>
</style>
